import { render } from "./UserSettings.vue?vue&type=template&id=c7b9157e&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=c7b9157e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b9157e"]])

export default __exports__